import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import {
  Button,
  Stack,
  Select,
  MenuItem,
  Divider,
  Switch,
} from '@mui/material'

import { Types } from '../../state/actionTypes'
import Layout from '../../common/components/Layout/Layout'
import './Settings.sass'

import {
  setLoading,
  defaultSuccess,
  defaultCatch,
  _dispatch as dispatch,
} from '../../state/actions'
import Field from '../../common/components/Field/Field'

function Settings(props) {
  const {
    lang,
    enabledInfraRedReader,
    enabledMrzWebcam,
    dispatch,
  } = props

  const { t } = useTranslation()
  const [lng, setLng] = useState(lang)
  const [infraRedReader, setEnabledInfraRedReader] = useState(enabledInfraRedReader ?? false)
  const [mrzWebcam, setMrzWebcam] = useState(enabledMrzWebcam ?? false)
  const [configInfraRedReader, setConfigInfraRedReader] = useState({ port: '', baudRate: 9600 });
  const [portsList, setPortsList] = useState([]);

  const handleSave = () => {
    dispatch({
      type: Types.SET_LANGUAGE,
      payload: lng
    })

    dispatch({
      type: Types.SET_INFRARED_READER,
      payload: { enabled: infraRedReader }
    })

    dispatch({
      type: Types.SET_MRZ_WEBCAM,
      payload: { enabled: mrzWebcam }
    })

    dispatch({
      type: Types.SET_SNACKBAR_DATA,
      payload: {
        open: true,
        message: t('saved'),
        severity: 'success',
        autoHideDuration: 1000
      }
    })

    if (window.electronAPI && window.electronAPI.setSerialConfig) {
      window.electronAPI.setSerialConfig(configInfraRedReader);
    }
  }

  // Cargar configuración y puertos al montar
  useEffect(() => {

    if (window.electronAPI) {
      // Pedir puertos disponibles
      window.electronAPI.listSerialPorts().then(ports => {
        setPortsList(ports);
      });

      // Pedir config actual
      window.electronAPI.getSerialConfig().then(currentConfig => {
        setConfigInfraRedReader(currentConfig);
      });

    } else {
      console.log('Corriendo en un navegador web estándar. El escáner infrarrojo no está disponible.');
    }
  }, []);

  const handlePort = value => {
    setConfigInfraRedReader(prev => ({
      ...prev,
      port: value
    }));
  };

  const handleBaudRate = value => {
    setConfigInfraRedReader(prev => ({
      ...prev,
      baudRate: Number(value)
    }));
  }


  return (
    <Layout title={t('settings')} style={{ padding: '0 34px' }}>
      <Stack spacing={5} className="Settings horizontal">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <label>{t('language')}</label>
          <Select
            className="filled-select"
            variant="filled"
            labelId="lang-label"
            value={lng}
            onChange={event => setLng(event.target.value)}
          >
            <MenuItem value='es'> {t('spanish')}</MenuItem>
            <MenuItem value='en'> {t('english')}</MenuItem>
          </Select>
        </Stack>
      </Stack>
      <Stack spacing={5} className="Settings horizontal">
        <Divider />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Stack spacing={1}>
            <label>{t('MRZ webcam')}</label>
            <p>{t('Enables reading the machine-readable zone of an ID or passport with the webcam.')}</p>
          </Stack>
          <Switch
            checked={mrzWebcam}
            onChange={event => setMrzWebcam(event.target.checked)}
          />
        </Stack>
      </Stack>
      {
        window.electronAPI &&
        <Stack spacing={5} className="Settings horizontal">
          <Divider />
          <Stack
            justifyContent="space-between"
            spacing={2}
          >
            <label>{t('Infrared Reader')}</label>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <p>{t('Enables communication with the Python Infrared Reader for autocompleting data in the Visit Form.')}</p>
              <Switch
                checked={infraRedReader}
                onChange={event => setEnabledInfraRedReader(event.target.checked)}
              />
            </Stack>
            {infraRedReader &&
              <div style={{ padding: '20px' }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={0}
                  >
                    <label>{t('Serial Port')}</label>
                    <Stack
                      direction="row"
                      justifyContent="end"
                      alignItems="center"
                      spacing={2}
                    >
                      <Select
                        variant="filled"
                        placeholder={t("port")}
                        value={configInfraRedReader.port}
                        onChange={event => handlePort(event.target.value)}
                      >
                        <MenuItem value="">{t("Select port manually")}</MenuItem>
                        {portsList.map(p => (
                          <MenuItem key={p.path} value={p.path}>
                            {p.path} ({p.manufacturer || 'n/a'})
                          </MenuItem>
                        ))}
                      </Select>
                      {configInfraRedReader.port === '' &&
                        <Field
                          type="text"
                          variant="filled"
                          fullWidth={false}
                          value={configInfraRedReader.port}
                          onChange={event => handlePort(event.target.value)}
                          placeholder={t("Port")}
                        />
                      }
                    </Stack>
                  </Stack>
                  <Field
                    type="number"
                    placeholder={t("Baud Rate")}
                    value={configInfraRedReader.baudRate}
                    onChange={event => handleBaudRate(event.target.value)}
                  />
                </Stack>
              </div>
            }
          </Stack>
        </Stack>
      }
      <div className='save-setting-button-wrapper'>
        <Button
          className='save-setting-button'
          sx={{ width: '272px' }}
          variant="contained"
          onClick={handleSave}
        >
          {t('save changes')}
        </Button>
      </div>
    </Layout>
  )
}

const mapDispatchToProps = {
  dispatch,
  setLoading,
  defaultSuccess,
  defaultCatch
}

const mapStateToProps = state => {
  return {
    lang: state.setting.lang,
    enabledInfraRedReader: state.setting.enabledInfraRedReader,
    enabledMrzWebcam: state.setting.enabledMrzWebcam,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)